import { HTTPClient, Session } from 'ywana-core8'
const auth = HTTPClient(window.AUTH || process.env.REACT_APP_AUTH, Session);
const http = HTTPClient(window.API || process.env.REACT_APP_API, Session);

/**
 * Authentication API
 */
export const AuthAPI = {

    authenticate(login, password) {
        const body = JSON.stringify({ login, password })
        return auth.POST('/authenticate', body)
    },

    forget(email) {
        const body = JSON.stringify({ email })
        return auth.POST('/forget', body)
    },

    me() {
        return http.GET('/me')
    }
}